import { createActionGroup } from '@ngrx/store';
import { zefActionFailPayload, zefActionPayload, zefActionSuccessPayload } from '@zerops/zef/core';
import { IntegrationTokenDelegationListResponse } from '@zerops/models/integration-token';
import { FEATURE_NAME } from './integration-token-delegation-base.constant';

export const integrationTokenDelegationActions = createActionGroup({
  source: FEATURE_NAME,
  events: {
    // Client-wide list (badges)
    'Load All Delegations': zefActionPayload<Record<string, never>>(),
    'Load All Delegations Success': zefActionSuccessPayload<IntegrationTokenDelegationListResponse>(),
    'Load All Delegations Fail': zefActionFailPayload,

    // Scoped list for one token (edit dialog)
    'Load Token Delegations': zefActionPayload<{ tokenId: string }>(),
    'Load Token Delegations Success': zefActionSuccessPayload<IntegrationTokenDelegationListResponse>(),
    'Load Token Delegations Fail': zefActionFailPayload
  }
});
